(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[314],{

/***/ 7960:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/petitions/[sharecode]",
      function () {
        return __webpack_require__(900);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3255);
/* harmony import */ var _bubble_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9637);
/* harmony import */ var _bubble_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bubble_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Bubble = function(_param) {
    var as = _param.as, className = _param.className, props = _objectWithoutProperties(_param, [
        "as",
        "className"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
        as: as,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_bubble_module_scss__WEBPACK_IMPORTED_MODULE_3__.bubble, className)
    }, props)));
};
Bubble.propTypes = {
    as: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
Bubble.defaultProps = {
    as: 'span'
};
/* harmony default export */ __webpack_exports__["Z"] = (Bubble);


/***/ }),

/***/ 3605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _typography_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(829);
/* harmony import */ var _progressBar_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1035);
/* harmony import */ var _progressBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_progressBar_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var ProgressBar = function(param) {
    var current = param.current, tiers = param.tiers, _label = param.label, label = _label === void 0 ? 'monthly donors' : _label;
    var validTiers = tiers.filter(function(tier) {
        return tier > current;
    });
    // A default that will at least make the gauge look reasonable correct
    // in cases where we bust through the provided range.
    var nextTier = validTiers.sort(function(a, b) {
        a > b;
    })[0] || Math.ceil(current * 1.25);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container ".concat(_progressBar_module_scss__WEBPACK_IMPORTED_MODULE_2__.progress),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("progress", {
                value: current,
                max: nextTier
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_typography_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "span",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        children: "".concat(current.toLocaleString(), " so far! ")
                    }),
                    "Let’s get to ".concat(nextTier.toLocaleString(), " ").concat(label, "!")
                ]
            })
        ]
    }));
};
ProgressBar.propTypes = {
    current: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
    tiers: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)).isRequired,
    label: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (ProgressBar);


/***/ }),

/***/ 900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _sharecode_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__(6299);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/progressBar/index.js
var progressBar = __webpack_require__(3605);
// EXTERNAL MODULE: ./src/components/buttons/cta.js + 2 modules
var cta = __webpack_require__(3576);
// EXTERNAL MODULE: ./src/components/typography/anchor.js
var typography_anchor = __webpack_require__(8472);
// EXTERNAL MODULE: ./src/components/bubble.js
var bubble = __webpack_require__(5527);
// EXTERNAL MODULE: ./src/components/layout.js + 10 modules
var layout = __webpack_require__(8492);
// EXTERNAL MODULE: ./src/components/petition/shareblock.js + 5 modules
var shareblock = __webpack_require__(6860);
;// CONCATENATED MODULE: ./src/components/petition/config.js
// prettier-ignore
// Used for progress bars
var PETITION_TIERS = [
    5,
    10,
    25,
    50,
    100,
    250,
    500,
    1000,
    2000,
    3000,
    5000,
    10000,
    25000,
    50000,
    75000,
    100000,
    250000,
    750000,
    1000000,
    1250000,
    1500000,
    1750000,
    2000000,
    2250000,
    2500000,
    2750000,
    3000000,
    3250000,
    3500000,
    3750000,
    4000000,
    4250000,
    4500000,
    4750000,
    5000000,
    5250000,
    5500000,
    5750000,
    6000000,
    6250000,
    6500000,
    6750000, 
];


// EXTERNAL MODULE: ./src/components/typography/heading.js
var typography_heading = __webpack_require__(9852);
// EXTERNAL MODULE: ./src/components/typography/text.js
var typography_text = __webpack_require__(829);
// EXTERNAL MODULE: ./src/images/shares/petition-share.png
var petition_share = __webpack_require__(4611);
// EXTERNAL MODULE: ./src/utilities/targets.js
var targets = __webpack_require__(1512);
// EXTERNAL MODULE: ./src/utilities/propTypes.js
var propTypes = __webpack_require__(4010);
;// CONCATENATED MODULE: ./src/lib/petitions.js
var PETITION_SIGNING_STATES = {
    OPEN: 'open',
    CLOSED: 'closed'
};
var fieldsListView = new Set([
    'petition_code',
    'subject',
    'state',
    'sent_timestamp',
    'target',
    'sign_count',
    'sign_status',
    // This is an object with one child attribute
    'trending', 
]);
var fieldsFullPetition = new Set([
    'petition_code',
    'subject',
    'message',
    'petitioner_name',
    'petitioner_code',
    'state',
    'sent_timestamp',
    'target',
    'sign_count',
    'sign_status',
    // This is an object with one child attribute
    'trending', 
]);
var trimPetitions = function(param) {
    var _petitions = param.petitions, petitions = _petitions === void 0 ? [] : _petitions, fieldsToKeep = param.fieldsToKeep;
    var trimmedPetitions = new Array(petitions.length);
    petitions.forEach(function(p, idx) {
        var slimPetition = {};
        fieldsToKeep.forEach(function(f) {
            var fieldValue = p[f];
            if (fieldValue) {
                slimPetition[f] = fieldValue;
            }
        });
        trimmedPetitions[idx] = slimPetition;
    });
    return trimmedPetitions;
};


// EXTERNAL MODULE: ./src/pages/petitions/petition-detail.module.scss
var petition_detail_module = __webpack_require__(2105);
// EXTERNAL MODULE: ./src/pages/common/petitions.module.scss
var petitions_module = __webpack_require__(877);
;// CONCATENATED MODULE: ./src/pages/petitions/[sharecode].js



















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var dateFormatWithoutYear = 'LLLL d'; // ie. October 20
var now = luxon.DateTime.local();
var PetitionMetadata = function(param) {
    var dateString = param.dateString, petition = param.petition, userCode = param.userCode;
    var name = userCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
        href: "/go/".concat(userCode),
        children: petition.petitioner_name
    }) : petition.petitioner_name;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
        as: "p",
        className: petition_detail_module.dateCreated,
        children: [
            "First sent ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                children: "on"
            }),
            " ",
            dateString,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                children: "by"
            }),
            " ",
            name,
            ' ',
            petition.trending.sign_count_period ? "\xb7 ".concat(petition.trending.sign_count_period.toLocaleString(), " signers in\n            the past 7 days") : null
        ]
    }));
};
var Petition = function(param) {
    var petition = param.petition;
    var router = (0,next_router.useRouter)();
    var url = router.asPath;
    var hasState = !!petition.state;
    var stateDetail = "(".concat(petition.state, " only) ");
    var targetDetail = (0,targets/* default */.Z)(petition.target);
    var date = luxon.DateTime.fromSeconds(petition.sent_timestamp);
    var isThisYear = date.year === now.year;
    var dateString = isThisYear ? date.toFormat(dateFormatWithoutYear) : date.toLocaleString(luxon.DateTime.DATE_FULL);
    var subject = petition.subject ? petition.subject : petition.message.substring(0, 79);
    var is_closed = petition.sign_status === PETITION_SIGNING_STATES.CLOSED;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        title: "Resistbot Petition: ".concat(subject),
        ogTitle: subject,
        dataType: layout/* DATA_TYPES.petition */.D.petition,
        description: "Text SIGN ".concat(petition.petition_code, " to 50409 to send this to your officials."),
        image: petition_share/* default */.Z,
        imageAltText: "A photo of a protest with signs like \"immigrants make America great,\" \"support equal rights,\" and, \"we will not be quiet we will not back down\" overlaid with white text reading \"take action.\"",
        canonicalPath: "/petitions/".concat(petition.petition_code),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: petition_detail_module.petitionMasthead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
                        as: "span",
                        className: petition_detail_module.letterTarget,
                        children: [
                            "An open letter ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "to"
                            }),
                            " ",
                            targetDetail,
                            ' ',
                            hasState ? stateDetail : ''
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_heading/* default */.Z, {
                        as: "h1",
                        size: "h1",
                        children: subject
                    }),
                    !is_closed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: petition_detail_module.progressBar,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(progressBar/* default */.Z, {
                                current: petition.sign_count,
                                tiers: PETITION_TIERS,
                                label: 'signers'
                            })
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: petition_detail_module.petitionContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: petition_detail_module.petitionBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_text/* default */.Z, {
                                className: petition_detail_module.message,
                                children: petition.message
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PetitionMetadata, {
                                dateString: dateString,
                                petition: petition,
                                userCode: petition.petitioner_code
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: petition_detail_module.petitionSidebar,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, {
                                sharecode: petition.petition_code,
                                is_closed: is_closed
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: petition_detail_module.moreSigs,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_heading/* default */.Z, {
                                        as: "h3",
                                        className: petitions_module.ctaHeading,
                                        size: "h3",
                                        children: "Already signed?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    "Text ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(bubble/* default */.Z, {
                                                        children: [
                                                            "PROMOTE ",
                                                            petition.petition_code
                                                        ]
                                                    }),
                                                    " to drive more signers."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Print this and post around campus or on your community bulletin board!"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    "Use the",
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                                        href: "https://apps.apple.com/us/app/resistbot/id1564775862",
                                                        children: "iOS app"
                                                    }),
                                                    ' ',
                                                    "to share with your contacts!"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shareblock/* ShareBlock */.T, {
                                        pathname: url,
                                        text: "Text SIGN ".concat(petition.petition_code, " to 50409")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var CTA = function(param) {
    var sharecode = param.sharecode, _is_closed = param.is_closed, is_closed = _is_closed === void 0 ? false : _is_closed;
    var params = !is_closed ? {
        keyword: "Sign ".concat(sharecode)
    } : {};
    var heading = !is_closed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_heading/* default */.Z, {
        as: "h2",
        className: petitions_module.ctaHeading,
        size: "h2",
        children: "Send to Your Officials"
    }) : null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: petitions_module.cta,
        children: [
            heading,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(cta/* default */.Z, _objectSpread({}, params))
        ]
    }));
};
CTA.propTypes = {
    sharecode: (prop_types_default()).string.isRequired,
    is_closed: (prop_types_default()).bool
};
Petition.propTypes = {
    petition: propTypes/* PetitionType */.Ni
};
var __N_SSP = true;
/* harmony default export */ var _sharecode_ = (Petition);


/***/ }),

/***/ 4010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T7": function() { return /* binding */ BlogPostDetailType; },
/* harmony export */   "XW": function() { return /* binding */ BlogPostTileType; },
/* harmony export */   "bg": function() { return /* binding */ LetterType; },
/* harmony export */   "WT": function() { return /* binding */ SiteStatsType; },
/* harmony export */   "Ni": function() { return /* binding */ PetitionType; },
/* harmony export */   "iU": function() { return /* binding */ PetitionTypeList; },
/* harmony export */   "Y4": function() { return /* binding */ MerchType; },
/* harmony export */   "Jp": function() { return /* binding */ SanityMerchImageType; },
/* harmony export */   "FO": function() { return /* binding */ KeywordType; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9685);


var SanityImageType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    asset: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        url: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    }).isRequired
}).isRequired;
var SanityMerchImageType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    altText: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    asset: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        url: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    }).isRequired
}).isRequired;
var BlogPostDetailType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    route: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    publishedAt: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    lastUpdated: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    title: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    mainImage: SanityImageType,
    body: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    featuredKeyword: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    authors: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    })),
    category: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    tags: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({}))
}).isRequired;
var BlogPostTileType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    route: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    publishedAt: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    title: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    mainImage: SanityImageType,
    category: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
}).isRequired;
var LetterType = (prop_types__WEBPACK_IMPORTED_MODULE_0___default().object);
var SiteStatsType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    lettersSent: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    recurringDonors: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    targetRecurringDonors: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    users: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    voterRegistrations: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired)
});
var PetitionType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    petition_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    petitioner_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    subject: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    message: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    petitioner_name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    state: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    sent_timestamp: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    target: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    sign_count: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    sign_status: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf([
        'open',
        'closed'
    ]),
    trending: prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        sign_count_period: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)
    }).isRequired
});
var PetitionTypeList = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    petition_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    subject: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    state: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    sent_timestamp: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    target: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    sign_count: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    sign_status: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf([
        'open',
        'closed'
    ]),
    trending: prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        sign_count_period: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)
    })
});
var MerchType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    _id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    image: SanityMerchImageType,
    name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    link: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
});
var KeywordType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    keyword: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_0___default().object))
});



/***/ }),

/***/ 1512:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var TARGET_TYPES = {
    all: '',
    national_all: 'the President and U.S. Congress',
    congress: 'the U.S. Congress',
    senior: 'the U.S. Senate',
    junior: 'the U.S. Senate',
    senate: 'the U.S. Senate',
    house: 'the U.S. House of Representatives',
    president: 'the President',
    state_all: 'State Governors & Legislatures',
    governor: 'State Governors',
    state_legislature: 'State Legislatures',
    state_upper: 'State Senates',
    state_lower: 'State Legislatures',
    dnc: 'the Democratic National Committee',
    governor_senate: 'State Governors and the U.S. Senate',
    obama: 'President Obama',
    mayor: 'Mayors',
    ceo: 'State Election Officials'
};
var getTargetTypeHumanName = function(abbreviation) {
    var abbrev = abbreviation.toLowerCase();
    return TARGET_TYPES[abbrev] || '';
};
/* harmony default export */ __webpack_exports__["Z"] = (getTargetTypeHumanName);


/***/ }),

/***/ 9637:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bubble":"bubble_bubble__Zpq6_"};

/***/ }),

/***/ 1035:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progress":"progressBar_progress__eefyx"};

/***/ }),

/***/ 877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cta":"petitions_cta__u8CHJ","ctaHeading":"petitions_ctaHeading__Bg_bj"};

/***/ }),

/***/ 2105:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"moreSigs":"petition-detail_moreSigs__Tb3sv","petitionContainer":"petition-detail_petitionContainer__Cq4OG","petitionMasthead":"petition-detail_petitionMasthead__TCyZP","progressBar":"petition-detail_progressBar__ev9k_","letterTarget":"petition-detail_letterTarget__ObPsb","dateCreated":"petition-detail_dateCreated__iQI_e","petitionBody":"petition-detail_petitionBody__siq5p","message":"petition-detail_message__mTHxT","petitionSidebar":"petition-detail_petitionSidebar__JFo_A"};

/***/ }),

/***/ 4611:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ("/_next/static/images/petition-share-3757b63a2e1ca42da7a3c50cc4268a0e.png");

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [569,193,498,323,122,774,888,179], function() { return __webpack_exec__(7960); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);